/* eslint-disable react/jsx-no-target-blank */
import React from 'react'

import iconTelegramm from '../assets/images/telegram.png'
import iconViber from '../assets/images/viber.png'
import iconFacebook from '../assets/images/facebook.png'

const Messengers = () => {
  return (
    <div className="messengers-container">
      <div className="title-container">
        <span className="title">Не знайшли відповідь? Зверніться до оператора</span>
      </div>
      <div className="container_messengers">
        <a href="https://t.me/ecobank_bot" rel='noopener noreferrer' target="_blank" className="messenger">
          <img src={iconTelegramm} alt="icon-telegram"/>
          <span className="name_messanger">Telegram</span>
        </a>
        <a href='viber://pa?chatURI=ecobank'  className="messenger">
          <img src={iconViber} alt="icon-viber"/>
          <span className="name_messanger">Viber</span>
        </a>
        <a href='http://m.me/Ukrgasbank'  target="_blank" className="messenger">
          <img src={iconFacebook} alt="icon-facebook"/>
          <span className="name_messanger">Facebook</span>
        </a>
      </div>
    </div>
  )
}

export default Messengers